import { Injectable } from '@angular/core';
import { TreeviewItem } from './treeview-item';

@Injectable()
export abstract class TreeviewI18n {
	abstract getFilterPlaceholder(): string;
	abstract getFilterNoItemsFoundText(): string;
	abstract getTooltipCollapseExpandText(isCollapse: boolean): string;
}

@Injectable()
export class DefaultTreeviewI18n extends TreeviewI18n {
	getFilterPlaceholder(): string {
		return 'Filter';
	}

	getFilterNoItemsFoundText(): string {
		return 'No existen elementos';
	}

	getTooltipCollapseExpandText(isCollapse: boolean): string {
		return isCollapse ? 'Expand' : 'Collapse';
	}
}
